import { Parser } from "@siteimprove/alfa-parser";
import { Token } from "../../../../syntax/index.js";
const { map, either } = Parser;
/**
 * @internal
 */
export var Position;
(function (Position) {
    Position.parseVertical = map(Token.parseIdent((ident) => ident.value === "top" || ident.value === "bottom"), (ident) => ident.value);
    Position.parseHorizontal = map(Token.parseIdent((ident) => ident.value === "left" || ident.value === "right"), (ident) => ident.value);
    Position.parse = either(Position.parseVertical, Position.parseHorizontal);
})(Position || (Position = {}));
//# sourceMappingURL=position.js.map